var _style, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__prefix__st0 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__prefix__st0",
    d: "M9.7 21.3c.6.6 1.6 1.1 2.3 1.1.7 0 1.7-.5 2.3-1.1.6-.6 1.5-1.1 2.2-1.1.6 0 1.9.4 2.9.9s2.2.1 2.9-.9c.5-.7.6-1.7.3-2.5 0-.1-.1-.2-.1-.3v-.1s0-.1-.1-.1c-.3-.6-.5-1.4-.5-1.9s.4-1.2.8-1.6c.5-.4.8-1.2.8-1.7s-.4-1.3-.8-1.7c-.5-.4-.8-1.1-.8-1.6s.3-1.4.6-2.1c.1-.2.1-.3.1-.5.2-.8.1-1.7-.4-2.4-.6-1-1.9-1.3-2.9-.9-1 .5-2.3.9-2.9.9-.6 0-1.6-.5-2.2-1.1s-1.5-1-2.2-1c-.7 0-1.7.5-2.3 1.1S8.2 3.8 7.5 3.8c-.6 0-1.8-.4-2.7-.8-.9-.5-2.2-.1-2.9.8-.5.8-.7 1.8-.5 2.5 0 .1.1.2.1.3.3.7.6 1.7.6 2.1 0 .5-.4 1.2-.8 1.6-.5.4-.8 1.2-.8 1.7s.4 1.3.8 1.7c.5.4.8 1.1.8 1.6 0 .4-.2 1.1-.5 1.8-.5.8-.4 2.1.3 3 .7 1 2 1.3 2.9.9.9-.5 2.1-.9 2.7-.9.7.1 1.6.6 2.2 1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 6.6v10.8H5.1V6.6h13.8m1-1H4.1v12.8h15.8V5.6z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__prefix__st0",
    d: "M4.1 15h15.8M9 15l3.4-3.4c.7-.7 1.8-.7 2.5 0l3.4 3.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__prefix__st0",
    cx: 7.9,
    cy: 9,
    r: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/stamp.df897455d7d5101e69fd6abf6777c875.svg";
export { ForwardRef as ReactComponent };